import { Component } from '@angular/core';
import { StatementsFacade } from '../../services/statements.facade';

@Component({
  standalone: false,
  selector: 'hospitable-statements-owners-list',
  templateUrl: './statements-owners-list.component.html',
  styleUrls: ['./statements-owners-list.component.css'],
})
export class StatementsOwnersListComponent {
  ownersState$ = this.statementsService.ownersState$;

  displayedColumns = ['name', 'email', 'phone', 'type', 'properties', 'actions'];

  constructor(private statementsService: StatementsFacade) {
    this.statementsService.getOwners();
  }
}
